import initialState from "./store";
import actions from "./actions";
import reducer from "./reducer";
import { useCallback, useReducer } from "react";
import { ContextProviderProps } from "../../types/contexts/context.types";
import { GroupOwner } from "../../types/groupOwner.types";
import GroupOwnerContext from "./groupOwnerContext";

const GroupOwnerContextProvider = ({ children }: ContextProviderProps): JSX.Element => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {
		groupOwner: state.groupOwner,
		setGroupOwner: useCallback(
			(groupOnwer: GroupOwner) => dispatch({ type: actions.SET_GROUP_OWNER, payload: groupOnwer }),
			[]
		)
	};

	return <GroupOwnerContext.Provider value={value}>{children}</GroupOwnerContext.Provider>;
};

export default GroupOwnerContextProvider;
